import script from "./AboutMe.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutMe.vue?vue&type=script&setup=true&lang=js"

import "./AboutMe.vue?vue&type=style&index=0&id=efe8bb2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efe8bb2a"]])

export default __exports__